/**
 * Single Row Template
 *
 * Creates a row of box units within a single building envelope.
 * Supports 1-20 units with auto-calculated or manually adjusted widths.
 */

import { Rows3 } from 'lucide-react'
import type { BuildingTemplate } from '../types'
import { singleRowParamsSchema, DEFAULT_SINGLE_ROW_VALUES, type SingleRowParams } from './params'
import { generateBuilding, generateUnits } from './generate'

/**
 * Single Row Template definition
 */
export const SingleRowTemplate: BuildingTemplate<SingleRowParams> = {
  id: 'single_row',
  name: 'Single Row Box Hangar',
  description: 'Multiple box units in a single row with shared walls',
  icon: Rows3,
  buildingType: 'box_hangar_single_row',

  generateBuilding,
  generateUnits,

  formSchema: singleRowParamsSchema,
  defaultValues: DEFAULT_SINGLE_ROW_VALUES,
}

// Re-export types and utilities
export { type SingleRowParams, singleRowParamsSchema, DEFAULT_SINGLE_ROW_VALUES } from './params'
export { generateBuilding, generateUnits } from './generate'
export {
  calculateSingleRowLayout,
  getRedistributedWidths,
  calculateOptimalUnitCount,
  calculateSuggestedBuildingLength,
  type SingleRowCalculationResult,
  type SuggestedFix,
} from './calculations'
